import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	registeringUser: false,
	registerUserError: null,

	sendingOTP: false,
	sendOTPError: null,

	verifyingOTP: false,
	verifyOTPError: null,

	fetchingPincodeDetails: false,
	pincodeDetails: {},
	fetchPincodeDetailsError: null,

	isCheckingUser: false,
	checkUserError: null,
};

const slice = createSlice({
	name: "@register",
	initialState,
	reducers: {
		registerUserBegin: (state) => {
			state.registeringUser = true;
			state.registerUserError = null;
		},
		registerUserSuccess: (state, action) => {
			state.registeringUser = false;
			state.registerUserError = null;
		},
		registerUserFailure: (state, action) => {
			state.registeringUser = false;
			state.registerUserError = action.payload.response;
		},
		sendOTPBegin: (state) => {
			state.sendingOTP = true;
			state.sendOTPError = null;
		},
		sendOTPSuccess: (state, action) => {
			state.sendingOTP = false;
			state.sendOTPError = null;
		},
		sendOTPFailure: (state, action) => {
			state.sendingOTP = false;
			state.sendOTPError = action.payload;
		},
		verifyOTPBegin: (state) => {
			state.verifyingOTP = true;
			state.verifyOTPError = null;
		},
		verifyOTPSuccess: (state, action) => {
			state.verifyingOTP = false;
			state.verifyOTPError = null;
		},
		verifyOTPFailure: (state, action) => {
			state.verifyingOTP = false;
			state.verifyOTPError = action.payload;
		},
		fetchPincodeDetailsBegin: (state) => {
			state.fetchingPincodeDetails = true;
			state.fetchPincodeDetailsError = null;
		},
		fetchPincodeDetailsSuccess: (state, action) => {
			state.fetchingPincodeDetails = false;
			state.pincodeDetails = action.payload.data;
			state.fetchPincodeDetailsError = null;
		},
		fetchPincodeDetailsFailure: (state, action) => {
			state.fetchingPincodeDetails = false;
			state.fetchPincodeDetailsError = action.payload;
		},
		checkUserBegin: (state) => {
			state.isCheckingUser = true;
			state.checkUserError = null;
		},
		checkUserSuccess: (state, action) => {
			state.isCheckingUser = false;
			state.checkUserError = null;
		},
		checkUserFailure: (state, action) => {
			state.isCheckingUser = false;
			state.checkUserError = action.payload;
		},
	},
});

export const {
	registerUserBegin,
	registerUserSuccess,
	registerUserFailure,

	sendOTPBegin,
	sendOTPSuccess,
	sendOTPFailure,

	verifyOTPBegin,
	verifyOTPSuccess,
	verifyOTPFailure,

	fetchPincodeDetailsBegin,
	fetchPincodeDetailsSuccess,
	fetchPincodeDetailsFailure,

	checkUserBegin,
	checkUserSuccess,
	checkUserFailure,
} = slice.actions;

export default slice.reducer;
